<div class="confirmation">
  <app-popup-top-line></app-popup-top-line>
  <div class="confirmation-header">
    <div class="title">{{ data.title }}</div>
    <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="onClose()" />
  </div>
  <div class="confirmation-body">
    <div class="content" [innerHtml]="data.content"></div>
  </div>
  <div class="confirmation-footer">
    <button class="cancel" [mat-dialog-close]="false" (click)="onClose()">
      {{ data.negativeOptionText }}
    </button>
    <button class="confirm" [mat-dialog-close]="true" cdkFocusInitial>
      {{ data.positiveOptionText }}
    </button>
  </div>
</div>
